__turbopack_context__.v({
  "links": "Links-module-scss-module__susQGa__links",
  "linksWrapper": "Links-module-scss-module__susQGa__linksWrapper",
});
